import { createAction } from '@reduxjs/toolkit';

export const formUpdateId = createAction('form/updateId');
export const formUpdateUID = createAction('form/updateUID');
export const formUpdateSID = createAction('form/updateSID');
export const formUpdateIsAdded = createAction('form/updateIsAdded');
export const formUpdateIsActive = createAction('form/updateIsActive');

export const formStore = createAction('form/store');
export const formClear = createAction('form/clear');

export const formUpdateform = createAction('form/updateform');
export const formUpdateError = createAction('form/updateError');
export const formUpdateStore = createAction('form/updateStore');
export const formUpdateRequest = createAction('form/updateRequest');

export const formUpdateButtonTitle = createAction('form/updateButtonTitle');
export const formUpdateResultData = createAction('form/updateResultData');
export const formUpdateSuccessMessage = createAction('form/updateSuccessMessage');
export const formUpdateResultAction = createAction('form/updateResultAction');
export const formUpdateViewType = createAction('form/updateViewType');
export const formUpdateFields = createAction('form/updateFields');

export const formUpdateIsAddress = createAction('form/updateIsAddress');
export const formUpdateIsComment = createAction('form/updateIsComment');
export const formUpdateIsEmail = createAction('form/updateIsEmail');
export const formUpdateIsName = createAction('form/updateIsName');
export const formUpdateIsPhone = createAction('form/updateIsPhone');

export const formUpdateIsAddressRequired = createAction('form/updateIsAddressRequired');
export const formUpdateIsCommentRequired = createAction('form/updateIsCommentRequired');
export const formUpdateIsEmailRequired = createAction('form/updateIsEmailRequired');
export const formUpdateIsNameRequired = createAction('form/updateIsNameRequired');
export const formUpdateIsPhoneRequired = createAction('form/updateIsPhoneRequired');

export const formUpdateButtonBackgroundColor = createAction('form/updateButtonBackgroundColor');
export const formUpdateButtonTextColor = createAction('form/updateButtonTextColor');
export const formUpdateButtonBorderColor = createAction('form/updateButtonBorderColor');
export const formUpdateButtonBorder = createAction('form/updateButtonBorder');
export const formUpdateButtonOpacity = createAction('form/updateButtonOpacity');
export const formUpdateButtonShadow = createAction('form/updateButtonShadow');
export const formUpdateButtonShadowColor = createAction('form/updateButtonShadowColor');
export const formUpdateButtonShape = createAction('form/updateButtonShape');

export const formUpdateHeadingTitle = createAction('form/updateHeadingTitle');
export const formUpdateHeadingDescription = createAction('form/updateHeadingDescription');
export const formUpdateHeadingTextAlign = createAction('form/updateHeadingTextAlign');
export const formUpdateHeadingImage = createAction('form/updateHeadingImage');
export const formUpdateHeadingDivider = createAction('form/updateHeadingDivider');

export const formUpdateSectionIsBackground = createAction('form/updateSectionIsBackground');
export const formUpdateSectionTextColor = createAction('form/updateSectionTextColor');
export const formUpdateSectionBackgroundColor = createAction('form/updateSectionBackgroundColor');
export const formUpdateSectionOpacity = createAction('form/updateSectionOpacity');
export const formUpdateSectionIsFullWidth = createAction('form/updateSectionIsFullWidth');
export const formUpdateSectionShadow = createAction('form/updateSectionShadow');
export const formUpdateSectionShadowColor = createAction('form/updateSectionShadowColor');
export const formUpdateSectionPadding = createAction('form/updateSectionPadding');
export const formUpdateSectionMargin = createAction('form/updateSectionMargin');
export const formUpdateSectionBackgroundType = createAction('form/updateSectionBackgroundType');
export const formUpdateSectionBackgroundImage = createAction('form/updateSectionBackgroundImage');
export const formUpdateSectionGradientColor1 = createAction('form/updateSectionGradientColor1');
export const formUpdateSectionGradientColor2 = createAction('form/updateSectionGradientColor2');
export const formUpdateSectionGradientDirection = createAction('form/updateSectionGradientDirection');
export const formUpdateSectionGradientOffset = createAction('form/updateSectionGradientOffset');
export const formUpdateSectionBorder = createAction('form/updateSectionBorder');
export const formUpdateSectionBorderColor = createAction('form/updateSectionBorderColor');
export const formUpdateSectionShadowBorderColor = createAction('form/updateSectionShadowBorderColor');
export const formUpdateSectionShape = createAction('form/updateSectionShape');
